import {BreadCrumbContent} from "../../common/types/common.types";
import {Breadcrumbs as BreadcrumbsMui, Link} from "@mui/material";
import {useNavigate} from "react-router-dom";

function Breadcrumbs(props: Props) {
  const navigate = useNavigate();

  function redirect(href: string) {
    navigate(href)
  }

  const breadcrumbs = props.data?.map((item, index) => {
    return <Link
      underline="hover"
      // href={item.href}
      onClick={() => redirect(item.href)}
      key={index}
      color={index === props.data.length - 1 ? 'text.primary' : 'inherit'}
    ><img src={item.icon} alt={item.name}/>{item.name}</Link>
  })

  return (
    <BreadcrumbsMui aria-label="breadcrumb" className={'breadcrumbs-content'}>
      {breadcrumbs}
    </BreadcrumbsMui>
  )
}

export default Breadcrumbs;

class Props {
  data: BreadCrumbContent[];
  maxDisplayItem?: number;
}
